var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { value: _vm.show, "max-width": "720" },
      on: { input: _vm.onClose },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _vm._v(" Vincular turma à trilha "),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.onClose(false)
                    },
                  },
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c("v-text-field", {
                staticClass: "mb-3",
                attrs: {
                  label: "Buscar turma",
                  "prepend-inner-icon": "mdi-magnify",
                  dense: "",
                  outlined: "",
                  "hide-details": "",
                },
                model: {
                  value: _vm.search,
                  callback: function ($$v) {
                    _vm.search = $$v
                  },
                  expression: "search",
                },
              }),
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.filteredItems,
                  loading: _vm.loading,
                  "show-select": "",
                  "item-key": "id",
                  dense: "",
                  "hide-default-footer": "",
                  "items-per-page": 50,
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.work_time",
                    fn: function ({ item }) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(item.work_time ? item.work_time.name : "—") +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.selected,
                  callback: function ($$v) {
                    _vm.selected = $$v
                  },
                  expression: "selected",
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { text: "" },
                  on: {
                    click: function ($event) {
                      return _vm.onClose(false)
                    },
                  },
                },
                [_vm._v("Cancelar")]
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    disabled: !_vm.selected.length,
                    loading: _vm.submitting,
                  },
                  on: { click: _vm.submit },
                },
                [_vm._v(" Vincular (" + _vm._s(_vm.selected.length) + ") ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }